/**
 * ----------------------------------------------------------------------
 * components/WishlistProducts.ts
 * Wishlist Products
 * - Dependencies: Swym app
 * - Pulls all products added to wishlit to page template
 *
 * - Important: This file was mildly adapted to work with typescript
 *   from swym's repo.
 *   https://gist.github.com/swym-public/e792039732102a09762080655351fb8b
 * -----------------------------------------------------------------------
*/
/* eslint-disable */
import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import axios from 'axios';
import { isUint16Array } from 'util/types';
import { EntryPlugin } from 'webpack';

declare global {
    interface Window {
        SwymCallbacks: any;
        _swat?: any;
        SwymUtils: any;
    }
}

@Component
export class WishlistProducts extends ThemeComponent {
    @Ref wrapper!: HTMLDivElement;
    @Ref button!: HTMLDivElement;

    init() {
        if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
        this.handleButtonClicks();
    }

    /**
     * Handle remove button click
     */
    handleButtonClicks() {
        const observer = new MutationObserver(() => {
            document.dispatchEvent(new Event('wishlistUpdated'));
        });
        observer.observe(this.wrapper, {
            subtree: true,
            childList: true
        });
    }
}

function getVariantInfo(variants: any) {
    try {
        let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
            variantinfo;
        if (variantKeys.length > 0) {
            variantinfo = variantKeys[0];
            if (variantinfo == "Default Title") {
                variantinfo = "";
            }
        } else {
            variantinfo = "";
        }
        return variantinfo;
    } catch (err) {
        return variants;
    }
}

function swymRenderWishlist(swat:any) {
    // Get wishlist items
    const productCardMarkup: string = `
    <div class="product-grid__products">
        {{#products}} 
        <div class="product-card">
            <div class="product-card__image">
                <a class="product-card__image-link" href="{{du}}" data-ref="link"></a>
                <img data-ref="image" src="{{iu}}" loading="lazy" alt="{{dt}}">

                <button 
                    id="swym-remove-productBtn" 
                    data-variant-id="{{epi}}" 
                    data-product-id="{{empi}}" 
                    class="product-card__swym-remove button button--primary button--inverse body-2"
                >Remove</button>
            </div>
        
            <a href="{{du}}" class="product-card__title" data-ref="link">
                {{dt}}
            </a>
        
            <div class="product-card__prices">
                <span data-ref="price" class="product-card__price product-card__price--normal">
                    {{cu}}{{pr}}
                </span>
            </div>

            <div class="product-card-swatches">
                {{variantinfo}}
            </div>
        </div>
        {{/products}}
    </div>
    `;

    swat.fetch((products: any) => {
        const wrapper = document.querySelector('[data-ref="wrapper"]')
        const button = document.querySelector('[data-ref="button"]')
        
        if (products.length === 0) {
            if (!wrapper) { return }
            wrapper.innerHTML = '';
            button?.classList.add('is-active');
        } else {

            const formattedWishlistedProducts = products.map((p:any) => {
                p = window.SwymUtils.formatProductPrice(p);

                p.isInCart = window._swat.platform.isInDeviceCart(p.epi) || (p.et == window._swat.EventTypes.addToCart);
                p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
                return p;
            });

            console.log(formattedWishlistedProducts)
            const productCardsMarkup = window.SwymUtils.renderTemplateString(productCardMarkup, {
                products: formattedWishlistedProducts
            });

            if (!wrapper) { return }
            wrapper.innerHTML = productCardsMarkup;
            attachClickListeners();
        }
    });
}

function productMarkUp(product:Shopify.Liquid.Product) {

}

function attachClickListeners() {
    const removeBtns = document.querySelectorAll("#swym-remove-productBtn");
    //   Remove Buttons
    for (let k = 0; k < removeBtns.length; k++) {
        removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
    }
}

function onRemoveBtnClick(e: any) {
    const epi = +e.currentTarget.getAttribute("data-variant-id");
    const empi = +e.currentTarget.getAttribute("data-product-id");
    
    window._swat.fetch(function(products: any) {
        products.forEach(function(product: any) {
            if (epi && empi && product.epi == epi && product.empi == empi) {
                window._swat.removeFromWishList(product, function() {
                    if (!window.SwymCallbacks) {
                        window.SwymCallbacks = [];
                    }
                    window.SwymCallbacks.push(swymRenderWishlist);
                });
            }
        });
    });
}
